
import { useState, useEffect } from "react";

export interface Message {
  role: "user" | "assistant";
  content: string;
}

// Create a hook to manage chat messages with local storage persistence
export const useChatMessages = () => {
  // Initialize messages from localStorage or empty array
  const [messages, setMessages] = useState<Message[]>(() => {
    const savedMessages = localStorage.getItem("chatMessages");
    return savedMessages ? JSON.parse(savedMessages) : [];
  });

  // Update localStorage when messages change
  useEffect(() => {
    localStorage.setItem("chatMessages", JSON.stringify(messages));
  }, [messages]);

  // Add a new message to the chat
  const addMessage = (message: Message) => {
    setMessages(prevMessages => [...prevMessages, message]);
  };

  // Clear all messages
  const clearMessages = () => {
    setMessages([]);
  };

  return {
    messages,
    addMessage,
    clearMessages
  };
};
